export default __webpack_public_path__ + "static/media/courseCardImage.6c4ab928.svg";